import React from 'react';
import styles from './index.module.css';
import { IntroductionScreen } from './IntroductionScreen';
import { AssetsScreen } from './AssetsScreen';
import { WebsitesScreen } from './Sites/WebsitesScreen';
import { FigmaModal } from './FigmaModal';
import { LoadingModal } from './LoadingModal';
import { useDesignAssetsState } from '../../../clients/providers/DesignAssets';
import { FigmaUploadProvider } from '../../../clients/providers/FigmaUpload';
import { useProjectSitesState } from '../../../clients/providers/ProjectSites';
import WelcomeBanner from './Guests/WelcomeBanner';
import QuickLinks from './Guests/QuickLinks';
import * as translations from './strings';
import { getLangKey } from '../../../javascript/models/Language';
import { Guide } from 'appJS/components/HelpGuideCard';
import { getGuideLink } from 'appJS/utils/HelpArticleButton';
import { HelpGuideCard } from 'appJS/components/HelpGuideCard';
import cx from 'classnames';
import { trackPage } from 'appJS/utils/analytics';

const strings = translations[getLangKey()];

const LoadingScreen = () => {
  return <div className={styles.header} />;
};

export const MainScreen = () => {
  const {
    data,
    status,
    viewGuestKanban,
    project,
    isGuest
  } = useDesignAssetsState();
  const { projectSites, isProjectSitesLoading } = useProjectSitesState();

  const renderIntroScreen = () => {
    if (status === 'loading' || isProjectSitesLoading) {
      return <LoadingScreen />;
    }

    if (status !== 'success') {
      return <AssetsScreen />;
    }

    return <IntroductionScreen />;
  };

  const showIntroScreen =
    !viewGuestKanban && !projectSites?.length && !data.length;
  const showAssetsScreen = !!data.length;

  trackPage('Client Project Board', {
    project_id: project.id,
    project_name: project.name
  });

  return (
    <div className={cx(styles.mainScreen, { [styles.guestScreen]: isGuest })}>
      {isGuest && (
        <div className={styles.guestIntroWrapper}>
          <WelcomeBanner project={project} />
          <QuickLinks project={project} />
        </div>
      )}
      <FigmaUploadProvider>
        <FigmaModal />
      </FigmaUploadProvider>
      <LoadingModal />
      <div className={styles.websitesAndFiles}>
        {projectSites?.length > 0 && <WebsitesScreen />}
        {(showAssetsScreen || showIntroScreen) && (
          <div className={styles.newOnboarding}>
            {showAssetsScreen && <AssetsScreen />}
            {showIntroScreen && renderIntroScreen()}
          </div>
        )}
      </div>
      {!isGuest && (
        <HelpGuideCard
          guide={Guide.WebsitesAndFiles}
          header={strings.projectSetup}
          message={strings.projectSetupMessage}
          links={[
            'startingNewProject',
            'installingBugherd',
            'defineYourWorkflow',
            'invitingYourTeam'
          ].map(key => getGuideLink({ articleKey: key, text: strings[key] }))}
          guideButton={{
            link: '/collections/41522-guide-getting-started-with-bugherd',
            articleId: 11467098
          }}
          divider
          hideOnSmallScreen
          isAdminView
        />
      )}
    </div>
  );
};
